// Peças visuais do onboarding Visor (D64), em classes Tailwind com os tokens
// n-*. Tamanhos em rem para seguir a fonte escolhida em Aparência.
const MOTION =
  'transition duration-200 ease-[cubic-bezier(.4,0,.2,1)] motion-reduce:transition-none';

export const CARD = 'bg-n-card border border-n-weak rounded-2xl p-6 max-md:p-4';

const BTN_BASE = `inline-flex items-center justify-center gap-2 h-12 px-5 rounded-xl font-medium whitespace-nowrap active:scale-[.98] ${MOTION}`;

export const BTN = `${BTN_BASE} bg-n-blue-9 text-white hover:bg-n-blue-10 disabled:bg-n-slate-3 disabled:text-n-slate-10 disabled:cursor-not-allowed`;

export const BTN_SECONDARY = `${BTN_BASE} bg-n-card text-n-slate-12 border border-[#8A94A6] hover:bg-n-slate-2 disabled:text-n-slate-10 disabled:border-n-weak disabled:cursor-not-allowed`;

export const BTN_LINK = `${BTN_BASE} px-2 text-n-blue-11 hover:underline`;

export const BTN_SMALL = '!h-10 !px-3.5 text-sm';

export const FIELD = `flex items-center gap-2.5 min-h-12 px-3.5 rounded-xl border border-[#8A94A6] bg-n-card text-n-slate-12 ${MOTION}`;

export const CHIP =
  'inline-flex items-center gap-1.5 h-[1.625rem] px-2.5 rounded-md text-[0.8125rem] font-medium whitespace-nowrap';

export const CHIP_TONES = {
  azul: 'bg-n-blue-3 text-n-blue-11',
  ok: 'bg-n-teal-3 text-n-teal-11',
  aviso: 'bg-n-amber-3 text-n-amber-11',
  exemplo: 'bg-n-violet-3 text-n-violet-11',
  neutro: 'bg-n-slate-3 text-n-slate-11',
};

export const TILE =
  'size-9 rounded-lg grid place-items-center flex-none [&>span]:size-5';

export const TILE_TONES = {
  azul: 'bg-n-blue-3 text-n-blue-11',
  ok: 'bg-n-teal-3 text-n-teal-11',
  aviso: 'bg-n-amber-3 text-n-amber-11',
  neutro: 'bg-n-slate-3 text-n-slate-10',
};

export const H1 =
  'text-[2rem] max-md:text-[1.625rem] leading-tight tracking-[-0.03em] font-medium text-n-slate-12';

export const SUB = 'text-base text-n-slate-11 max-w-[40rem] mt-2.5';

export const SMALL = 'text-[0.8125rem] text-n-slate-10';

export const ENTER =
  'animate-[fade-in-up_200ms_cubic-bezier(.4,0,.2,1)] motion-reduce:animate-none';

export { MOTION };
